module.exports = __webpack_public_path__ + "explore/images/eoy/beekeeper.90fc354fae63a8de1ace627936fcaf3d.png";